export function getCantDeleteTaskMessage(intl, cantDeleteTaskReason) {
	switch (cantDeleteTaskReason) {
		case 'HAS_LOCKED_TIME':
			return intl.formatMessage({id: 'common.task_delete_locked'});
		case 'HAS_INVOICED_TIME':
			return intl.formatMessage({id: 'task.cant_delete_reason.invoice_time_regs'});
		case 'HAS_TIME_REGS':
			return intl.formatMessage({id: 'task.cant_delete_reason.time_regs'});
		case 'HAS_OTHER_PEOPLES_TIME_REGS':
			return intl.formatMessage({id: 'task.cant_delete_reason.other_peoples_time_regs'});
		case 'JIRA':
			return intl.formatMessage({id: 'task.cant_delete_reason.jira'});
		case 'GITHUB':
			return intl.formatMessage({id: 'task.cant_delete_reason.github'});
		case 'UNIT4':
			return intl.formatMessage({id: 'task.cant_delete_reason.unit4'});
		case 'NO_USER_TYPE':
		default:
			return intl.formatMessage({id: 'common.no_delete_rights'});
	}
}
